import * as React from 'react'

import { useDispatch } from 'react-redux'

import { trackUserAddRemoveRecipe } from 'actions/loggingmanager'
import type { RecipeUUID } from 'reducers/menu-recipes/recipes'

import { type AddRecipeInfo, useAddValidRecipeToBasket } from './useAddValidRecipeToBasket'

export type AddRecipeByUuidFn = ReturnType<typeof useAddRecipeByUuid>
export const useAddRecipeByUuid = () => {
  const addValidRecipeToBasket = useAddValidRecipeToBasket()
  const dispatch = useDispatch()

  return React.useCallback(
    (
      recipeId: RecipeUUID,
      view?: string,
      recipeInfo?: AddRecipeInfo,
      orderId?: string,
      isOrderRecipe?: boolean,
    ) => {
      addValidRecipeToBasket(recipeId, view, recipeInfo, orderId, isOrderRecipe)
      dispatch(trackUserAddRemoveRecipe())
    },
    [dispatch, addValidRecipeToBasket],
  )
}
